<template>
  <div>
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $tc("privateRateCardGroup") }}</div>
        <div class="section-subTitle my-2">
          {{ $tc("listofall") }} {{ $tc("privateRateCardGroup") }}
        </div>
      </div>
      <div>
        <router-link
          v-if="$can('create', 'Private Rate Card')"
          variant="default"
          class="btn-blue"
          to="private-rate-card"
          >{{ $tc("add") }}</router-link
        >
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          @input="searchRateCardGroupList"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>

      <div class="d-flex align-items-center">
        <div class="d-flex mx-2">
          <div class="mb-2 mr-2" style="width: 225px">
            <div class="dropdown-curve-container">
              <label :class="selectedCinema.length > 0 ? 'shift-up' : ''">
                Search By Cinema
              </label>
              <div class>
                <b-dropdown
                  :disabled="isRoleID"
                  :text="selectedCinema"
                  variant="dropdown-curve"
                  class="w-100"
                >
                  <!-- _getCountryList(item.label, null) -->
                  <b-dropdown-item
                    v-for="(dropdownItem, dropdownIndex) in cinemaList"
                    :key="dropdownIndex"
                    href="#"
                    @click="onDropdownChange($event, dropdownItem)"
                    >{{ dropdownItem.cine_name }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </div>
          <FilterByStatusDropdown
            :onSelect="
              (filterIsActive) => {
                filter_is_active = filterIsActive;
                // this.getRateCardGroupList();
              }
            "
          />
          <b-button variant="default" @click="onFetch()" class="btn-blue">{{
            $t("fetch")
          }}</b-button>
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <!-- LIST VIEW -->
    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th class="text-left" style="width: 120px">
            <span class="pr-3">{{ $tc("status") }}</span>
          </th>
          <th>
            <img
              v-if="this.columnName != 'rc_g_name'"
              @click="onSortValue('rc_g_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('rc_g_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('rc_g_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("Rate Card Group") }}
          </th>
          <!--          <th v-if="$can('update', 'Private Rate Card')">-->
          <!--            Edit-->
          <!--          </th>-->
        </tr>
      </thead>
      <tbody v-if="RateCardGroup.length > 0">
        <tr v-for="(item, key) in RateCardGroup" :key="key">
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <StatusDot
                :status="item.rc_g_is_active == 'Y' ? 'active' : 'inactive'"
              />
              <span
                v-if="$can('update', 'Private Rate Card')"
                class="edit-icon ml-4 blue-icon"
                @click="goToRoute('/cinema-manager/private-rate-card', item)"
                style="cursor: pointer"
                v-b-tooltip="'Edit'"
                tabindex="0"
              >
                <i class="edit-pen icon blue-icon"></i>
              </span>
            </div>
          </td>

          <td>{{ $tc(item.rc_g_name, 1) }}</td>

          <!--<td v-if="$can('update', 'Private Rate Card')">
            <router-link
              class="btn-blue"
              :to="`/cinema-manager/private-rate-card?id=${item.rc_g_id}`"
            > {{ 'Edit' }}</router-link>
          </td>-->
        </tr>
      </tbody>
      <tbody v-else>
        <tr class="text-center">
          <td colSpan="2">
            <NoRecords />
          </td>
        </tr>
      </tbody>
    </table>

    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";
import { Role, CLIENT_NAME } from "@/helper/Role";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      gridView: false,
      listView: true,
      RateCardGroup: [],
      customErrors: {
        message: "",
      },
      //sorting
      isSort: false,
      isAscending: false,
      columnName: "",
      orderBy: "",

      debounce: null,
      searchValue: "",
      filter_is_active: "Y",
      cinema_id: "",
      selectedCinema: "",
      cinemaListCopy: [],
      cinemaList: [],
      selectedid: "",
    };
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    this.isRoleID1 = this.secureStore.get("USINFO").role_id;
    // this.getRateCardGroupList();
    this.getviewingnumber();
    if (true) {
      this.isRoleID = false;
      this.getCinemaList(obj);
    } else {
      this.getCinemaList(obj);
    }
  },
  methods: {
    onSortValue(columnName, orderBy) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderBy = orderBy;
      this.getRateCardGroupList();
    },
    onFetch: function () {
      this.getRateCardGroupList();
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getRateCardGroupList(this.selectedid);
      } else {
        this.currentPage = event;
        this.getRateCardGroupList(this.selectedid);
      }
    },
    /* eslint-disable */
    goToRoute: function (path, item) {
      console.log("item :", item);
      const { rc_g_id } = item;
      let p = path;

      if (path === "/cinema-manager/private-rate-card") {
        if (CLIENT_NAME.QFX == this.CLIENT_SETUP_NAME) {
          p = `${path}-qfx`;
        }

        if (CLIENT_NAME.EPIX == this.CLIENT_SETUP_NAME) {
          p = `${path}-exclusive-tax`;
        }

        if (CLIENT_NAME.WOW == this.CLIENT_SETUP_NAME) {
          p = `${path}-exclusive-tax`;
        }

        if (CLIENT_NAME.ROONGTA == this.CLIENT_SETUP_NAME) {
          p = `${path}-with-gst-sc`;
        }
      }

      this.$router.push({
        path: p,
        query: {
          id: rc_g_id,
        },
      });
    },
    searchRateCardGroupList: function (search) {
      this.getRateCardGroupList();
    },
    getCinemaList: function (cine_id) {
      MasterService.GetCinemas({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.cinemaList = data.Records;
            this.cinemaListCopy = data.Records;
            this.cinemaList.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                this.onDropdownChange(null, x);
              }
            });
            this.rows = data.totalRows;
          } else {
            //  Show Error Message
            console.log("data.message :", data.message);
          }
        })
        .catch((error) => {
          console.log("Catch Error On getCinemaList :", error);
        });
    },
    onDropdownChange: function (event, item) {
      this.selectedCinema = item.cine_name;
      this.selectedid = item.cine_id;
      this.searchCinema = "";
      // this.getRateCardGroupList(this.selectedid);
    },
    getRateCardGroupList: function (cinema_id) {
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderBy,
        searchValue: this.searchValue,
        is_private_rate_card: "Y",
        filter_is_active: this.filter_is_active,
        cinema_id: this.selectedid || cinema_id,
      };
      this.RateCardGroup = [];
      CinemasService.GetRateCardGroup(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.RateCardGroup = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.customErrors.message = data.message;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          this.$toasted.show(data.error);
        });
    },

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/RatecardComponents/listPrivateRateCard.vue